import React from "react";
import { ArrowRight, Users, Zap, Bell, ExternalLink } from "lucide-react";
export function App() {
  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <main className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-16">
            Присоединяйтесь к нашему эксклюзивному Telegram-сообществу
          </h1>
         
          <a
            href="https://t.me/yourchannel"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 rounded-full bg-[#0088cc] text-white font-medium hover:bg-[#0077b5] transition-colors"
          >
            Присоединиться к каналу <ArrowRight className="ml-2 h-5 w-5" />
          </a>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <Zap className="h-6 w-6 text-[#0088cc]" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Мгновенные обновления</h3>
            <p className="text-gray-600">
              Первыми получайте важные новости и обновления прямо на
              свой телефон.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <Users className="h-6 w-6 text-[#0088cc]" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Доступ к сообществу</h3>
            <p className="text-gray-600">
              Присоединяйтесь к нашему растущему сообществу активных участников.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <Bell className="h-6 w-6 text-[#0088cc]" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Эксклюзивный контент</h3>
            <p className="text-gray-600">
              Получите доступ к премиум-контенту, недоступному в других местах.
            </p>
          </div>
        </div>
        <div className="text-center mb-8">
          
          <div className="flex justify-center gap-4">
            <img
              src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=80&h=80&fit=crop&crop=faces"
              alt="Member"
              className="w-10 h-10 rounded-full border-2 border-white"
            />
            <img
              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=faces"
              alt="Member"
              className="w-10 h-10 rounded-full border-2 border-white"
            />
            <img
              src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=80&h=80&fit=crop&crop=faces"
              alt="Member"
              className="w-10 h-10 rounded-full border-2 border-white"
            />
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-500">
              +9.9k
            </div>
          </div>
        </div>
        <div className="text-center">
          <a
            href="https://t.me/yourchannel"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 rounded-full bg-gray-900 text-white font-medium hover:bg-gray-800 transition-colors"
          >
            Присоединиться сейчас <ExternalLink className="ml-2 h-5 w-5" />
          </a>
        </div>
      </main>
    </div>
  );
}
